import {QueryClient} from '@tanstack/react-query';
import {DehydratedQueryOptions} from './type';

/**
 * queryClient의 queries를 순회하며 [queryHash]: queryOptions 형태의 객체를 반환합니다.
 */
export function getDehydratedOptions(
  queryClient: QueryClient
): DehydratedQueryOptions {
  const queries = queryClient.getQueryCache().getAll();

  return queries.reduce<DehydratedQueryOptions>((acc, query) => {
    return {
      ...acc,
      [query.queryHash]: query.options as DehydratedQueryOptions[string],
    };
  }, {});
}
